import React, { useState, useEffect, useRef } from "react";

import AOS from "aos";

import "aos/dist/aos.css";

import "./Hero.css";

import Goa from "../../assets/cities/goa.png"

import Jaipur from "../../assets/cities/jaipur.png";

import Manali from "../../assets/cities/manali.png";

import Ladakh from "../../assets/cities/ladakh.png";

import Kerala from "../../assets/cities/kerala.png";

import Andaman from "../../assets/cities/andaman.png";

import { useNavigate } from "react-router-dom";

import { Lock, EyeOff, Phone, Check, Recycle, Hotel, Train, Bus, Palmtree, Calendar, MapPinCheck, MapPinHouse, BriefcaseBusiness, Plane, GraduationCap, User, BriefcaseBusinessIcon, Shield, Earth, Moon, Building2, Warehouse, ChevronDown, MessageCircle } from "lucide-react";

import { ENABLE_TRAINS } from "../../config/features";

import { useAIChat } from "../AI/AIChatContext";

import MakeBeeTripLogo from "../../assets/planelogo.jpeg";

import hotelApi from "../../services/hotelSearchApi";
import { useCities } from "../../services/usecitiesbus";



// ─── Navbar search form cache (keeps last search after overlay closes/reopens) ───

function loadCachedForm(key, fallback) {

  try {

    const saved = JSON.parse(sessionStorage.getItem(key) || "null");

    if (saved) return { ...fallback, ...saved };

  } catch { /* ignore */ }

  return fallback;

}

function cacheForm(key, form) {

  try { sessionStorage.setItem(key, JSON.stringify(form)); } catch { /* ignore */ }

}


const HERO_AIRPORTS_API =
  `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/api/flight-search/airports`;


// ─── Existing search data/helpers ───────────────────────────────
const CITIES = [
  "Delhi (DEL)", "Mumbai (BOM)", "Bangalore (BLR)", "Chennai (MAA)",
  "Hyderabad (HYD)", "Kolkata (CCU)", "Pune (PNQ)", "Ahmedabad (AMD)",
  "Goa (GOI)", "Jaipur (JAI)", "Kochi (COK)", "Lucknow (LKO)",
  "Srinagar (SXR)", "Manali", "Dubai (DXB)", "Singapore (SIN)",
  "Bangkok (BKK)", "London (LHR)", "New York (JFK)", "Paris (CDG)",
];

const CLASS_TYPES = ["Economy", "Premium Economy", "Business", "First Class"];

const renderIconNode = (icon, props = {}) => {
  if (!icon) return null;
  if (React.isValidElement(icon)) return icon;
  if (typeof icon === "function" || typeof icon === "object") {
    return React.createElement(icon, props);
  }
  return icon;
};

const extractCode = (value) => {
  const text = String(value || "").trim();
  const parenthesized = text.match(/\(([A-Z0-9]{2,5})\)/i);
  if (parenthesized?.[1]) return parenthesized[1].toUpperCase();
  if (/^[A-Z0-9]{2,5}$/i.test(text)) return text.toUpperCase();
  return "";
};

const formatHeroDate = (iso) => {
  if (!iso) {
    return { day: "--", month: "----", yearShort: "", weekday: "Select date" };
  }

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return { day: "--", month: "----", yearShort: "", weekday: "Invalid date" };
  }

  const fullYear = date.toLocaleDateString("en-US", { year: "numeric" });
  return {
    day: date.toLocaleDateString("en-US", { day: "2-digit" }),
    month: date.toLocaleDateString("en-US", { month: "short" }),
    yearShort: fullYear.slice(-2),
    weekday: date.toLocaleDateString("en-US", { weekday: "long" }),
  };
};

function HeroDateCard({ label, value, min, onChange }) {
  const inputRef = useRef(null);
  const formatted = formatHeroDate(value);
  const hasValue = Boolean(value);

  const openPicker = () => {
    if (!inputRef.current) return;
    if (typeof inputRef.current.showPicker === "function") {
      try {
        inputRef.current.showPicker();
      } catch {
        inputRef.current.focus();
      }
    } else {
      inputRef.current.focus();
    }
  };

  return (
    <div className="date-field">
      <div className="hero-date-picker">
        <div
          className="hero-date-card"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openPicker();
            }
          }}
        >
          <div className="hero-date-card-top">
            <span className="hero-date-card-label">{label}</span>
            <ChevronDown className="hero-date-card-chevron" size={14} />
          </div>
          <div className="hero-date-card-main">
            <div className="hero-date-card-icon"><Calendar height={16} width={16} /></div>
            <div className="hero-date-card-body">
              <div className="hero-date-card-day">
                {hasValue ? `${formatted.day} ${formatted.month}'${formatted.yearShort}` : "Select date"}
              </div>
              <div className="hero-date-card-weekday">{formatted.weekday}</div>
            </div>
          </div>
        </div>
        <input
          ref={inputRef}
          type="date"
          className="hero-date-card-input"
          value={value}
          min={min}
          onChange={(e) => onChange(e.target.value)}
          onClick={openPicker}
          aria-label={label}
        />
      </div>
    </div>
  );
}

const formatHeroMonth = (value) => {
  if (!value) return null;
  const [y, m] = value.split("-").map(Number);
  if (!y || !m) return null;
  const date = new Date(y, m - 1, 1);
  if (Number.isNaN(date.getTime())) return null;
  return {
    month: date.toLocaleDateString("en-US", { month: "short" }),
    year: String(y),
  };
};

function HeroMonthCard({ label, value, onChange }) {
  const inputRef = useRef(null);
  const formatted = formatHeroMonth(value);

  const openPicker = () => {
    if (!inputRef.current) return;
    if (typeof inputRef.current.showPicker === "function") {
      try {
        inputRef.current.showPicker();
      } catch {
        inputRef.current.focus();
      }
    } else {
      inputRef.current.focus();
    }
  };

  return (
    <div className="date-field">
      <div className="hero-date-picker">
        <div
          className="hero-date-card"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openPicker();
            }
          }}
        >
          <div className="hero-date-card-top">
            <span className="hero-date-card-label">{label}</span>
            <ChevronDown className="hero-date-card-chevron" size={14} />
          </div>
          <div className="hero-date-card-main">
            <div className="hero-date-card-icon"><Calendar height={16} width={16} /></div>
            <div className="hero-date-card-body">
              <div className="hero-date-card-day">
                {formatted ? `${formatted.month} ${formatted.year}` : "Select month"}
              </div>
              <div className="hero-date-card-weekday">Best time to plan</div>
            </div>
          </div>
        </div>
        <input
          ref={inputRef}
          type="month"
          className="hero-date-card-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onClick={openPicker}
          aria-label={label}
        />
      </div>
    </div>
  );
}

const SPECIAL_FARES = [
  { id: "regular", label: "Regular", icon: <Plane height={15} width={15} /> },
  { id: "student", label: "Student", icon: <GraduationCap height={15} width={15} /> },
  { id: "senior", label: "Senior Citizen", icon: <User height={15} width={15} /> },
  { id: "armed-forces", label: "Armed Forces", icon: <Shield height={15} width={15} /> },
  { id: "marine", label: "Marine", icon: <BriefcaseBusinessIcon height={15} width={15} /> },
];

// ─── Homepage content data ──────────────────────────────────────
// Static discovery content only. These sections never start live supplier
// searches or hotel polling; the existing search forms above remain unchanged.

const HOME_DESTINATIONS = [
  { id: "goa", city: "Goa", category: "Beach escapes", image: Goa, query: "Goa" },
  { id: "manali", city: "Manali", category: "Mountain breaks", image: Manali, query: "Manali" },
  { id: "jaipur", city: "Jaipur", category: "Heritage & culture", image: Jaipur, query: "Jaipur" },
  { id: "kerala", city: "Kerala", category: "Backwaters & nature", image: Kerala, query: "Kerala" },
  { id: "ladakh", city: "Ladakh", category: "Adventure", image: Ladakh, query: "Ladakh" },
  { id: "andaman", city: "Andaman", category: "Island holidays", image: Andaman, query: "Andaman" },
];

const HOME_AIRLINES = [
  { name: "IndiGo", code: "6E" },
  { name: "Air India", code: "AI" },
  { name: "Air India Express", code: "IX" },
  { name: "SpiceJet", code: "SG" },
];

const HOME_SERVICES = [
  {
    id: "flights",
    title: "Flights",
    text: "Domestic & international air travel",
    icon: Plane,
    route: "/flights",
  },
  {
    id: "hotels",
    title: "Hotels",
    text: "Search stays with live availability",
    icon: Hotel,
    route: "/hotels",
  },
  {
    id: "buses",
    title: "Buses",
    text: "Intercity bus travel",
    icon: Bus,
    route: "/buses",
  },
  {
    id: "holidays",
    title: "Holidays",
    text: "Explore holiday packages",
    icon: Palmtree,
    route: "/holidays",
  },
];

const HOME_TRAVEL_STYLES = [
  { title: "Beach escapes", text: "For slow mornings and coastal breaks", image: Goa },
  { title: "Mountain journeys", text: "For fresh air, views and adventure", image: Manali },
  { title: "Heritage getaways", text: "For culture, food and old cities", image: Jaipur },
  { title: "Island holidays", text: "For tropical stays and sea time", image: Andaman },
];

const HERO_SITE_SEARCH = [
  { id: "flights", label: "Flights", type: "Service", route: "/flights", keywords: "flight flights air ticket airfare" },
  { id: "hotels", label: "Hotels", type: "Service", route: "/hotels", keywords: "hotel hotels stay room accommodation" },
  ...(ENABLE_TRAINS
    ? [{ id: "trains", label: "Trains", type: "Service", route: "/trains", keywords: "train trains railway rail ticket" }]
    : []),
  { id: "buses", label: "Buses", type: "Service", route: "/buses", keywords: "bus buses coach ticket" },
  { id: "holidays", label: "Holidays", type: "Service", route: "/holidays", keywords: "holiday holidays package tour trip vacation" },
  ...HOME_DESTINATIONS.map((destination) => ({
    id: `destination-${destination.id}`,
    label: destination.city,
    type: "Destination",
    route: `/holidays?destination=${encodeURIComponent(destination.query)}`,
    keywords: `${destination.city} ${destination.category} destination travel`,
  })),
];

// Keep the index available for any existing site-search integration without
// rendering or fetching anything on the homepage.
void HERO_SITE_SEARCH;

// ─── City Autocomplete ───────────────────────────────────────────


function CityInput({
  label,
  icon,
  value,
  onChange,
  placeholder,
  wrapperClassName = "",
  options = CITIES,
  clearOnFocus = false,
  suggestionIcon: SuggestionIcon = Plane,
}) {
  const [open, setOpen] = useState(false);
const ref = useRef(null);


  useEffect(() => {
    const handler = (e) => {
      if (!ref.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

 const query = String(value || "").trim().toLowerCase();

const filtered = (options || [])
  .filter((item) => {
    const airport = String(item || "").trim().toLowerCase();

    if (!query) return true;

    // Match the start of any word in the airport label.
    return airport.split(/[\s,()-]+/).some((word) =>
      word.startsWith(query)
    );
  })
  .slice(0, 10);

  return (
    <div
      className={`city-input-wrap ${wrapperClassName} ${
        open ? "city-input-wrap--open" : ""
      }`}
      ref={ref}
    >
      <label className="field-label">
        {renderIconNode(icon, { size: 14 })} {label}
      </label>

      <input
        className="city-input"
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => {
          if (clearOnFocus) onChange("");
          setOpen(true);
        }}
        onClick={() => setOpen(true)}
        aria-label={label}
        role="combobox"
        aria-expanded={open}
        aria-autocomplete="list"
      />

      {value && (
        <span className="city-code">
          {value.match(/\(([A-Z0-9]{2,5})\)/i)?.[1] || ""}
        </span>
      )}

      {open && (
  <ul className="city-dropdown" role="listbox">
          {filtered.length > 0 ? (
            filtered.map((city) => (
              <li
                key={city}
                role="option"
                aria-selected={city === value}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(city);
                  setOpen(false);
                }}
              >
                <span className="city-dd-icon">
  <SuggestionIcon size={18} />
</span>
                <span>{city}</span>
              </li>
            ))
          ) : (
            <li className="city-no-results">No matching airports found</li>
          )}
        </ul>
      )}
    </div>
  );
}


function HotelLocationInput({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!ref.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () =>
      document.removeEventListener("mousedown", handleOutsideClick);
  }, []);


  useEffect(() => {
    const query = String(value || "").trim();
    const searchQuery = query.length >= 2 ? query : "Goa";

    if (!open) {
      return;
    }

    let cancelled = false;

    const timer = setTimeout(async () => {
      setLoading(true);

      try {
        const data = await hotelApi.autosuggest(searchQuery);

        const list = Array.isArray(data)
          ? data
          : data?.autoSuggestions ||
            data?.suggestions ||
            data?.data ||
            data?.results ||
            [];

        const normalized = list
          .map((item) => {
            if (typeof item === "string") {
              return {
                label: item,
                key: item,
                original: item,
              };
            }

            if (!item || typeof item !== "object") {
              return null;
            }

            const label =
              item.name ||
              item.cityName ||
              item.city_name ||
              item.label ||
              item.hotelName ||
              item.hotel_name ||
              item.locationName ||
              item.location_name ||
              item.displayName ||
              item.display_name;

            if (!label) return null;

            return {
              label: String(label),
              key: String(
                item.locationId ||
                  item.location_id ||
                  item.hotelId ||
                  item.hotel_id ||
                  item.id ||
                  item.code ||
                  label
              ),
              original: item,
            };
          })
          .filter(Boolean);

        if (!cancelled) {
          setSuggestions(
            normalized.filter(
              (item, index, all) =>
                all.findIndex(
                  (other) =>
                    other.label.toLowerCase() ===
                    item.label.toLowerCase()
                ) === index
            )
          );
        }
      } catch (error) {
        if (!cancelled) {
          setSuggestions([]);
          console.error("Hotel autosuggest failed:", error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }, 250);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [value, open]);


  return (
    <div
      className={`city-input-wrap hotel-city-wrap ${
        open ? "city-input-wrap--open" : ""
      }`}
      ref={ref}
    >
      <label className="field-label">
        <Building2 size={15} /> CITY, PROPERTY OR LANDMARK
      </label>

      <input
        className="city-input"
        value={value}
        placeholder="Search hotels or destinations..."
        autoComplete="off"
        role="combobox"
        aria-expanded={open}
        aria-autocomplete="list"
        
onFocus={() => {
  setOpen(true);
}}

        onClick={() => setOpen(true)}
        onChange={(event) => {
          onChange(event.target.value);
          setOpen(true);
        }}
      />

      {open && (
        <ul className="city-dropdown" role="listbox">
          
{loading ? (
  <li className="city-no-results">Searching hotels...</li>
) : suggestions.length > 0 ? (
  suggestions.map((item) => (
  <li
    key={item.key}
    role="option"
    aria-selected={item.label === value}
    onMouseDown={(event) => {
      event.preventDefault();
      onChange(item.label);
      setOpen(false);
    }}
  >
    <span className="city-dd-icon">
      <Building2 size={18} />
    </span>
    <span>{item.label}</span>
  </li>
))
) : value.trim().length >= 2 ? (
  <li className="city-no-results">
    No matching hotels found
  </li>
) : (
  <li className="city-no-results">
    {loading ? "Searching hotels..." : "No suggestions available"}
  </li>
)}

        </ul>
      )}
    </div>
  );
}




// ─── Travellers Picker ──────────────────────────────────────────

function TravellersPicker({ adults, children, infants, classType, onChange }) {

  const [open, setOpen] = useState(false);

  const ref = useRef(null);

  const total = adults + children + infants;



  useEffect(() => {

    const handler = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };

    document.addEventListener("mousedown", handler);

    return () => document.removeEventListener("mousedown", handler);

  }, []);



  const Counter = ({ label, sub, val, field, min = 0, max = Infinity }) => (

  <div className="counter-row">

    <div>

      <div className="counter-label">{label}</div>

      <div className="counter-sub">{sub}</div>

    </div>



    <div className="counter-btns">

      <button

        type="button"

        onClick={() => val > min && onChange({ [field]: val - 1 })}

        disabled={val <= min}

      >

        −

      </button>



      <span>{val}</span>



      <button

        type="button"

        onClick={() => val < max && onChange({ [field]: val + 1 })}

        disabled={val >= max}

      >

        +

      </button>

    </div>

  </div>

);



  return (

    <div className="travellers-wrap" ref={ref}>

      <label className="field-label"><BriefcaseBusiness height={15} width={15} /> TRAVELLERS & CLASS</label>

      <div className="travellers-display" onClick={() => setOpen(!open)}>

        <span className="travellers-count">{total}</span>

        <span className="travellers-meta">

          {total === 1 ? "Traveller" : "Travellers"} · {classType}

        </span>

        <span className="travellers-arrow">{open ? "▲" : "▼"}</span>

      </div>

      {open && (

        <div className="travellers-dropdown">

          <Counter

  label="Adults"

  sub="12+ yrs"

  val={adults}

  field="adults"

  min={1}

/>



<Counter

  label="Children"

  sub="2–11 yrs"

  val={children}

  field="children"

  max={adults * 4}

/>



<Counter

  label="Infants"

  sub="Under 2 yrs"

  val={infants}

  field="infants"

  max={adults}

/>

          <div className="class-select-wrap">

            <label className="field-label" style={{ fontSize: "11px" }}>CABIN CLASS</label>

            <div className="class-pills">

              {CLASS_TYPES.map(c => (

                <button

  type="button"

  key={c}

  className={`class-pill ${classType === c ? "class-pill--active" : ""}`}

  onClick={() => onChange({ classType: c })}

>

                  {c}

                </button>

              ))}

            </div>

          </div>

          <button

  type="button"

  className="done-btn"

  onClick={() => setOpen(false)}

>

  Done

</button>

        </div>

      )}

    </div>

  );

}



// ─── Flight Search Form ─────────────────────────────────────────

const getTodayISO = () => {

  const today = new Date();

  const year = today.getFullYear();

  const month = String(today.getMonth() + 1).padStart(2, "0");

  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;

};



const addDaysISO = (dateString, days = 1) => {

  if (!dateString) return getTodayISO();

  const date = new Date(`${dateString}T00:00:00`);

  date.setDate(date.getDate() + days);

  const year = date.getFullYear();

  const month = String(date.getMonth() + 1).padStart(2, "0");

  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;

};



const FLIGHT_FORM_KEY = "navFlightSearchForm";



export function FlightSearch({ inNavbar = false } = {}) {

  const navigate = useNavigate();

  
const [flightAirportOptions, setFlightAirportOptions] = useState([]);

useEffect(() => {
  const controller = new AbortController();

  fetch(HERO_AIRPORTS_API, {
    headers: { Accept: "application/json" },
    signal: controller.signal,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Airport API failed: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      if (!Array.isArray(data.airports)) {
        throw new Error("Airport API did not return an airports array");
      }

      const options = data.airports
        .filter((airport) => airport?.code)
        .map((airport) => {
          const city = airport.city || airport.code;
          const airportName =
            airport.airport &&
            airport.airport.toLowerCase() !== city.toLowerCase()
              ? ` - ${airport.airport}`
              : "";
          const country = airport.country ? `, ${airport.country}` : "";

          return `${city}${airportName}${country} (${String(
            airport.code
          ).toUpperCase()})`;
        });

      setFlightAirportOptions([...new Set(options)]);
    })
    .catch((error) => {
      if (error.name !== "AbortError") {
        console.error("Hero airport loading failed:", error);
      }
    });

  return () => controller.abort();
}, []);


  const [tripType, setTripType] = useState("oneway");

const [flightSearchError, setFlightSearchError] = useState("");

const [multiCityError, setMultiCityError] = useState("");

const isReturnTrip = tripType === "round" || tripType === "special-round";

  const [form, setForm] = useState(() =>

    loadCachedForm(FLIGHT_FORM_KEY, {

      from: "Delhi (DEL)", to: "Mumbai (BOM)",

      departure: "", returnDate: "",

      adults: 1, children: 0, infants: 0,

      classType: "Economy", specialFare: "regular",

    })

  );



  useEffect(() => {

    cacheForm(FLIGHT_FORM_KEY, form);

  }, [form]);



  // Multi city legs — each leg has from, to, date

  const [legs, setLegs] = useState([

    { from: "Delhi (DEL)", to: "Mumbai (BOM)", date: "" },

    { from: "Mumbai (BOM)", to: "Goa (GOI)", date: "" },

  ]);



  const swap = () => setForm(p => ({ ...p, from: p.to, to: p.from }));

  const update = (patch) =>

  setForm((prev) => {

    const next = { ...prev, ...patch };



    if ("adults" in patch) {

      next.adults = Math.max(1, next.adults);



      next.children = Math.min(

        next.children,

        next.adults * 4

      );



      next.infants = Math.min(

        next.infants,

        next.adults

      );

    }



    return next;

  });



  // Multi city helpers

  const updateLeg = (index, patch) => {

    setLegs((prev) => {

      const next = prev.map((leg, i) =>

        i === index ? { ...leg, ...patch } : leg

      );



      // Every later leg must remain at least one day after the previous leg.

      if ("date" in patch && patch.date) {

        for (let i = index + 1; i < next.length; i += 1) {

          const previousDate = next[i - 1].date;

          if (previousDate && (!next[i].date || next[i].date <= previousDate)) {

            next[i] = {

              ...next[i],

              date: addDaysISO(previousDate, 1),

            };

          }

        }

      }



      return next;

    });

  };



  const addLeg = () => {

    if (legs.length >= 5) return; // max 5 legs

    const lastLeg = legs[legs.length - 1];

    setLegs((prev) => [

      ...prev,

      {

        from: lastLeg.to,

        to: "",

        // Keep the date unselected. The picker min will enforce the sequence.

        date: "",

      },

    ]);

  };



  const removeLeg = (index) => {

    if (legs.length <= 2) return; // min 2 legs

    setLegs(prev => prev.filter((_, i) => i !== index));

  };



  return (



    <div className="search-card" data-aos="fade-up" data-aos-delay="100">



      {/* Trip Type Tabs */}

      <div className="trip-tabs">

        {["oneway", "round", "special-round", "multi"].map(t => (

          <button

            key={t}

            className={`trip-tab ${tripType === t ? "trip-tab--active" : "trip-tab--inactive"}`}

            aria-pressed={tripType === t}

            onClick={() => setTripType(t)}

          >

            {t === "oneway" ? "One Way" : t === "round" ? "Round Trip" : t === "special-round" ? "Special Round Trip" : "Multi City"}

          </button>

        ))}

      </div>



      {/* ── ONE WAY / ROUND TRIP ── */}

      {tripType !== "multi" && (

        <div className="search-fields">

          <div className="from-to-wrap">

          
<CityInput
  label="FROM"
  icon={<MapPinHouse height={15} width={15} />}
  value={form.from}
  onChange={(v) => update({ from: v })}
  placeholder="City or Airport"
  options={flightAirportOptions}
  clearOnFocus
/>
<button
  type="button"
  className="swap-btn-hero"
  onClick={swap}
  title="Swap cities"
>
  ⇄
</button>
<CityInput
  label="TO"
  icon={<MapPinCheck height={15} width={15} />}
  value={form.to}
  onChange={(v) => update({ to: v })}
  placeholder="City or Airport"
  options={flightAirportOptions}
  clearOnFocus
/>

          </div>



          <div className="date-fields">

            <HeroDateCard

              label="DEPART"

              value={form.departure}

              min={new Date().toISOString().split("T")[0]}

              onChange={(value) => update({ departure: value })}

            />

            {isReturnTrip && (

              <HeroDateCard

                label="RETURN"

                value={form.returnDate}

                min={form.departure || new Date().toISOString().split("T")[0]}

                onChange={(value) => update({ returnDate: value })}

              />

            )}

            {tripType === "oneway" && (

              <div className="date-field date-field--ghost" onClick={() => setTripType("round")}>

                <label className="field-label"><Calendar height={15} width={15} /> RETURN</label>

                <div className="date-ghost">+ Add Return Date</div>

              </div>

            )}

          </div>



          <TravellersPicker

            adults={form.adults} children={form.children}

            infants={form.infants} classType={form.classType}

            onChange={update}

          />



          {flightSearchError && (

  <div

    className="flight-form-error"

    role="alert"

    style={{

      marginBottom: 10,

      padding: "10px 12px",

      borderRadius: 8,

      background: "#fef2f2",

      border: "1px solid #fecaca",

      color: "#b91c1c",

      fontSize: 13,

      fontWeight: 600,

    }}

  >

    {flightSearchError}

  </div>

)}



          <button type="button" className="search-submit-btn"

onClick={() => {

  const today = getTodayISO();

  const fromCode = extractCode(form.from);

  const toCode = extractCode(form.to);



  if (!form.from || !fromCode) {

    setFlightSearchError("Please select a valid departure city from the suggestions.");

    return;

  }



  if (!form.to || !toCode) {

    setFlightSearchError("Please select a valid arrival city from the suggestions.");

    return;

  }



  if (fromCode === toCode) {

    setFlightSearchError("Departure and arrival city cannot be the same.");

    return;

  }



  if (!form.departure) {

    setFlightSearchError("Please select a departure date.");

    return;

  }



  if (form.departure < today) {

    setFlightSearchError("Departure date cannot be in the past.");

    return;

  }



  if (

    isReturnTrip &&

    (!form.returnDate || form.returnDate < form.departure)

  ) {

    setFlightSearchError("Return date cannot be before the departure date.");

    return;

  }



  setFlightSearchError("");



  const params = new URLSearchParams({

  from: form.from,

  to: form.to,

  fromCode,

  toCode,

  tripType:

    tripType === "oneway"

      ? "One Way"

      : tripType === "special-round"

        ? "Special Round Trip"

        : "Round Trip",

  departDate: form.departure,

  returnDate: isReturnTrip ? form.returnDate : "",

  adults: String(form.adults || 1),

  children: String(form.children || 0),

  infants: String(form.infants || 0),

  classType: form.classType,

  fare: form.specialFare,

});



  navigate(`/flights?${params.toString()}`);

}}>

            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.5">

              <circle cx="8.5" cy="8.5" r="5.5" /><path d="M15 15l-3-3" />

            </svg>

            Search Flights

          </button>

        </div>

      )}



      {/* ── MULTI CITY ── */}

      {tripType === "multi" && (

        <div>

          <div className="multi-city-wrap">

            {legs.map((leg, i) => (

              <div className="multi-city-row" key={i}>  

                <div className="multi-city-row-num">

                  <span className="multi-city-row-num__icon"><Plane size={14} /></span>

                  <span className="multi-city-row-num__text">Leg {i + 1}</span>

                </div>

                <div className="from-to-wrap">

                  <CityInput

                    label="FROM"

                    icon={<MapPinHouse height={15} width={15} />}

                    value={leg.from}

                    onChange={(v) => updateLeg(i, { from: v })}

                    placeholder="City or Airport"
                    options={flightAirportOptions}
clearOnFocus

                  />

                  <button

                    className="swap-btn-hero"

                    onClick={() => updateLeg(i, { from: leg.to, to: leg.from })}

                    title="Swap"

                  >⇄</button>

                  <CityInput

                    label="TO"

                    icon={<MapPinCheck height={15} width={15} />}

                    value={leg.to}

                    onChange={(v) => {

                      updateLeg(i, { to: v });

                      // Auto-fill next leg's FROM

                      if (legs[i + 1] !== undefined) {

                        updateLeg(i + 1, { from: v });

                      }

                    }}

                    placeholder="City or Airport"
                    options={flightAirportOptions}
clearOnFocus

                  />

                </div>

                <HeroDateCard

                  label={`LEG ${i + 1} DEPART`}

                  value={leg.date}

                  min={i === 0 ? getTodayISO() : addDaysISO(legs[i - 1].date, 1)}

                  onChange={(value) => updateLeg(i, { date: value })}

                />

                {legs.length > 2 && (

                  <button className="remove-city-btn" onClick={() => removeLeg(i)} title="Remove leg">✕</button>

                )}

              </div>

            ))}

          </div>



          <div className="multi-city-actions">

            {legs.length < 5 && (

              <button className="add-city-btn" onClick={addLeg}>

                + Add Another City

              </button>

            )}

            <div className="multi-city-action-controls">

              <TravellersPicker

                adults={form.adults} children={form.children}

                infants={form.infants} classType={form.classType}

                onChange={update}

              />

              {multiCityError && (

  <div

    className="flight-form-error"

    role="alert"

    style={{

      marginBottom: 10,

      padding: "10px 12px",

      borderRadius: 8,

      background: "#fef2f2",

      border: "1px solid #fecaca",

      color: "#b91c1c",

      fontSize: 13,

      fontWeight: 600,

    }}

  >

    {multiCityError}

  </div>

)}

              <button type="button" className="search-submit-btn"

                onClick={() => {

                  const today = getTodayISO();



let validationError = "";



for (let i = 0; i < legs.length; i += 1) {

  const leg = legs[i];



  if (!leg.from || !leg.to) {

    validationError = `Please select departure and arrival city for Leg ${i + 1}.`;

    break;

  }



  const fromCode = extractCode(leg.from);

  const toCode = extractCode(leg.to);



  if (!fromCode || !toCode) {

    validationError = `Please select valid departure and arrival cities for Leg ${i + 1}.`;

    break;

  }



  if (fromCode === toCode) {

    validationError = `Departure and arrival city cannot be the same for Leg ${i + 1}.`;

    break;

  }



  if (!leg.date) {

    validationError = `Please select a departure date for Leg ${i + 1}.`;

    break;

  }



  if (leg.date < today) {

    validationError = `Leg ${i + 1} departure date cannot be in the past.`;

    break;

  }



  if (i > 0 && leg.date <= legs[i - 1].date) {

    validationError = `Leg ${i + 1} departure date must be after Leg ${i}.`;

    break;

  }

}



if (validationError) {

  setMultiCityError(validationError);

  return;

}



setMultiCityError("");



                  const params = new URLSearchParams({

  tripType: "Multi City",

  legs: JSON.stringify(

    legs.map((leg) => ({

      from: leg.from,

      to: leg.to,

      fromCode: extractCode(leg.from),

      toCode: extractCode(leg.to),

      date: leg.date,

    }))

  ),

  adults: String(form.adults || 1),

  children: String(form.children || 0),

  infants: String(form.infants || 0),

  classType: form.classType || "Economy",

  fare: form.specialFare || "regular",

});

                  navigate(`/flights?${params.toString()}`);

                }}>

                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.5">

                  <circle cx="8.5" cy="8.5" r="5.5" /><path d="M15 15l-3-3" />

                </svg>

                Search Flights

              </button>

            </div>

          </div>

        </div>

      )}



      {/* Special Fares */}

      <div className="special-fares">

        <span className="fares-label">Special Fares:</span>

        {SPECIAL_FARES.map(f => (

          <button key={f.id}

            className={`fare-pill ${form.specialFare === f.id ? "fare-pill--active" : ""}`}

            onClick={() => update({ specialFare: f.id })}>

            <span className="fare-pill__icon" aria-hidden="true">{f.icon}</span>

            <span className="fare-pill__label">{f.label}</span>

          </button>

        ))}

      </div>

    </div>

  );

}



// ─── Hotel Search ───────────────────────────────────────────────

const HOTEL_FORM_KEY = "navHotelSearchForm";



export function HotelSearch({ inNavbar = false } = {}) {

  const navigate = useNavigate();

  const [roomsOpen, setRoomsOpen] = useState(false);

const roomsRef = useRef(null);

  const [error, setError] = useState("");

  const [form, setForm] = useState(() =>

    loadCachedForm(HOTEL_FORM_KEY, {

  city: "Goa",

  checkin: "",

  checkout: "",

  rooms: 1,

  adults: 2,

  children: 0,

  childAges: [],

})

  );



  useEffect(() => {

    cacheForm(HOTEL_FORM_KEY, form);

  }, [form]);



  useEffect(() => {

  const close = (e) => {

    if (!roomsRef.current?.contains(e.target)) {

      setRoomsOpen(false);

    }

  };



  document.addEventListener("mousedown", close);



  return () => {

    document.removeEventListener("mousedown", close);

  };

}, []);



  const update = (patch) => setForm((f) => ({ ...f, ...patch }));

  return (

    <div className="search-card" data-aos="fade-up" data-aos-delay="100">

  <div className="search-fields">

        {/* <div className="city-input-wrap hotel-city-wrap">

          <label className="field-label"><Building2 height={15} width={15} /> CITY, PROPERTY OR LANDMARK</label> */}

      
<HotelLocationInput
  value={form.city}
  onChange={(city) => update({ city })}
/>


        {/* </div> */}



        <div className="date-fields">

          <HeroDateCard

            label="CHECK-IN"

            value={form.checkin}

            min={new Date().toISOString().split("T")[0]}

            onChange={(value) => update({ checkin: value })}

          />

          <HeroDateCard

            label="CHECK-OUT"

            value={form.checkout}

            min={form.checkin || new Date().toISOString().split("T")[0]}

            onChange={(value) => update({ checkout: value })}

          />

        </div>



       <div className="hotel-rooms-wraps" ref={roomsRef}>

  <label className="field-label">

    <Warehouse height={15} width={15} /> ROOMS & GUESTS

  </label>



  <button

    type="button"

    className="hotel-guests-summary"

    onClick={() => setRoomsOpen((open) => !open)}

  >

    <span>

      {form.rooms} Room{form.rooms !== 1 ? "s" : ""},{" "}

      {form.adults} Adult{form.adults !== 1 ? "s" : ""}

      {form.children > 0

        ? `, ${form.children} Child${form.children !== 1 ? "ren" : ""}`

        : ""}

    </span>



    <ChevronDown

      size={15}

      className={roomsOpen ? "hotel-guests-chevron is-open" : "hotel-guests-chevron"}

    />

  </button>



  {roomsOpen && (

    <div className="hotel-guests-dropdown">



      {/* Rooms */}

      <div className="hotel-guests-row">

        <span>Rooms</span>



        <div className="hotel-guests-counter">

          <button

            type="button"

            onClick={() =>

              form.rooms > 1 &&

              update({

                rooms: form.rooms - 1,

                adults: Math.max(form.rooms - 1, form.adults),

              })

            }

            disabled={form.rooms <= 1}

          >

            −

          </button>



          <strong>{form.rooms}</strong>



          <button

            type="button"

            onClick={() =>

              update({

                rooms: form.rooms + 1,

                adults: Math.max(form.adults, form.rooms + 1),

              })

            }

          >

            +

          </button>

        </div>

      </div>



      {/* Adults */}

      <div className="hotel-guests-row">

        <span>Adults</span>



        <div className="hotel-guests-counter">

          <button

            type="button"

            onClick={() => {

  if (form.adults <= form.rooms) return;



  const nextAdults = form.adults - 1;

  const nextChildren = Math.min(

    form.children,

    nextAdults

  );



  update({

    adults: nextAdults,

    children: nextChildren,

    childAges: form.childAges.slice(0, nextChildren),

  });

}}

            disabled={form.adults <= form.rooms}

          >

            −

          </button>



          <strong>{form.adults}</strong>



          <button

            type="button"

            onClick={() =>

              update({ adults: form.adults + 1 })

            }

          >

            +

          </button>

        </div>

      </div>



      {/* Children */}

      <div className="hotel-guests-row">

        <span>Children</span>



        <div className="hotel-guests-counter">

          <button

            type="button"

            onClick={() => {

              if (form.children <= 0) return;



              update({

                children: form.children - 1,

                childAges: form.childAges.slice(

                  0,

                  form.children - 1

                ),

              });

            }}

            disabled={form.children <= 0}

          >

            −

          </button>



          <strong>{form.children}</strong>



          <button

  type="button"

  disabled={form.children >= form.adults}

  onClick={() => {

    if (form.children >= form.adults) return;



    update({

      children: form.children + 1,

      childAges: [...form.childAges, ""],

    });

  }}

>

  +

</button>

        </div>

      </div>



      {/* Child ages */}

      {form.children > 0 && (

        <div className="hotel-child-age-section">

          <div className="hotel-child-age-title">

            Child ages at check-in *

          </div>



          {Array.from(

            { length: form.children },

            (_, index) => (

              <div

                className="hotel-child-age-row"

                key={index}

              >

                <span>Child {index + 1}</span>



                <select

                  value={form.childAges[index] ?? ""}

                  onChange={(e) => {

                    const ages = [...form.childAges];

                    ages[index] = e.target.value;



                    update({ childAges: ages });

                    setError("");

                  }}

                >

                  <option value="" disabled>

                    Select age

                  </option>



                  {Array.from(

                    { length: 13 },

                    (_, age) => (

                      <option key={age} value={age}>

                        {age === 0

                          ? "Under 1 year"

                          : `${age} year${age !== 1 ? "s" : ""}`}

                      </option>

                    )

                  )}

                </select>

              </div>

            )

          )}

        </div>

      )}



      {error && (

        <div className="hotel-form-error">

          {error}

        </div>

      )}



      <button

        type="button"

        className="hotel-guests-done"

        onClick={() => {

          if (

            form.children > 0 &&

            (

              form.childAges.length !== form.children ||

              form.childAges.some(

                (age) =>

                  age === "" ||

                  age === null ||

                  age === undefined

              )

            )

          ) {

            setError("Select an age for each child.");

            return;

          }



          setError("");

          setRoomsOpen(false);

        }}

      >

        Done

      </button>

    </div>

  )}

</div>



        <button

          type="button"

          className="search-submit-btn"

          onClick={() => {

            if (

  form.children > 0 &&

  (

    form.childAges.length !== form.children ||

    form.childAges.some(

      (age) => age === "" || age === null || age === undefined

    )

  )

) {

  setError("Select an age for each child.");

  return;

}



setError("");



const params = new URLSearchParams({

  city: form.city || "Goa",

  checkIn: form.checkin || "",

  checkOut: form.checkout || "",

  rooms: String(form.rooms || 1),

  adults: String(form.adults || 1),

  children: String(form.children || 0),

  childAges: JSON.stringify(

    (form.childAges || []).map(Number)

  ),

});



navigate(`/hotels?${params.toString()}`);

          }}

        >

          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.5">

            <circle cx="8.5" cy="8.5" r="5.5" />

            <path d="M15 15l-3-3" />

          </svg>

          Search Hotels

        </button>

      </div>

    </div>

  );

}



// ─── Train Search ───────────────────────────────────────────────

const TRAIN_FORM_KEY = "navTrainSearchForm";



export function TrainSearch({ inNavbar = false } = {}) {

  const navigate = useNavigate();

  const [form, setForm] = useState(() =>

    loadCachedForm(TRAIN_FORM_KEY, { from: "Delhi (DEL)", to: "Mumbai (BOM)", date: "", quota: "General" })

  );



  useEffect(() => {

    cacheForm(TRAIN_FORM_KEY, form);

  }, [form]);

   const update = (patch) => setForm(p => ({ ...p, ...patch }));

  const QUOTAS = ["General", "Ladies", "Lower Berth", "Tatkal", "Premium Tatkal"];

  return (

    <div className="search-card" data-aos="fade-up" data-aos-delay="100">



      <div className="search-fields">

        <div className="from-to-wrap">

          <CityInput label="FROM" icon={<MapPinHouse height={15} width={15} />} value={form.from} onChange={v => update({ from: v })} placeholder="Station or City" />

          <button className="swap-btn" onClick={() => update({ from: form.to, to: form.from })}>⇄</button>

          <CityInput label="TO" icon={<MapPinCheck height={15} width={15} />} value={form.to} onChange={v => update({ to: v })} placeholder="Station or City" />

        </div>

        <div className="date-fields">

          <HeroDateCard

            label="DEPARTURE"

            value={form.date}

            min={new Date().toISOString().split("T")[0]}

            onChange={(value) => update({ date: value })}

          />

          <div className="date-field">

            <label className="field-label"><BriefcaseBusiness height={15} width={15} /> QUOTA</label>

            <select className="date-input" value={form.quota} onChange={e => update({ quota: e.target.value })}>

              {QUOTAS.map(q => <option key={q}>{q}</option>)}

            </select>

          </div>

        </div>

        <button

          type="button"

          className="search-submit-btn"

          onClick={() => {

            const params = new URLSearchParams({

              from: form.from || "",

              to: form.to || "",

              date: form.date || "",

              quota: form.quota || "General",

            });

            navigate(`/trains?${params.toString()}`);

          }}

        >

          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.5">

            <circle cx="8.5" cy="8.5" r="5.5" /><path d="M15 15l-3-3" />

          </svg>

          Search Trains

        </button>

      </div>

    </div>

  );

}



// ─── Bus Search ─────────────────────────────────────────────────


const BUS_FORM_KEY = "navBusSearchForm";

export function BusSearch({ inNavbar = false } = {}) {
  const navigate = useNavigate();

  const {
    cities,
    getCityId,
    getAllCities,
    loading: citiesLoading,
  } = useCities();

  const allBusCities = React.useMemo(() => {
    if (typeof getAllCities === "function") {
      return getAllCities();
    }

    return [];
  }, [getAllCities, cities]);

  const [form, setForm] = useState(() =>
    loadCachedForm(BUS_FORM_KEY, {
      from: "",
      to: "",
      date: "",
    })
  );

  const [error, setError] = useState("");

  useEffect(() => {
    cacheForm(BUS_FORM_KEY, form);
  }, [form]);

  const update = (patch) => {
    setForm((previous) => ({ ...previous, ...patch }));
    setError("");
  };

  const swapCities = () => {
    update({
      from: form.to,
      to: form.from,
    });
  };

  const handleSearch = () => {
    const from = form.from.trim();
    const to = form.to.trim();

    if (citiesLoading) {
      setError("Please wait while bus cities load.");
      return;
    }

    if (!from || !to) {
      setError("Please select both departure and destination cities.");
      return;
    }

    const fromId = getCityId(from);
    const toId = getCityId(to);

    if (fromId == null || toId == null) {
      setError("Please select valid cities from the suggestions.");
      return;
    }

    if (String(fromId) === String(toId)) {
      setError("Departure and destination cities cannot be the same.");
      return;
    }

    if (form.date && form.date < new Date().toLocaleDateString("en-CA")) {
      setError("Journey date cannot be in the past.");
      return;
    }

    const params = new URLSearchParams({
      from,
      to,
      date: form.date || "",
    });

    setError("");
    navigate(`/buses?${params.toString()}`);
  };

  return (
    <div
      className="search-card"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      <div className="search-fields">
        <div className="from-to-wrap">
          <CityInput
  label="FROM"
  icon={<MapPinHouse height={15} width={15} />}
  suggestionIcon={Bus}
  value={form.from}
  onChange={(value) => update({ from: value })}
  placeholder={citiesLoading ? "Loading cities..." : "Origin city"}
  options={allBusCities}
  clearOnFocus
/>

          <button
            type="button"
            className="swap-btn"
            onClick={swapCities}
            title="Swap cities"
            aria-label="Swap departure and destination"
          >
            ⇄
          </button>

          <CityInput
  label="TO"
  icon={<MapPinCheck height={15} width={15} />}
  suggestionIcon={Bus}
  value={form.to}
  onChange={(value) => update({ to: value })}
  placeholder={citiesLoading ? "Loading cities..." : "Destination city"}
  options={allBusCities}
  clearOnFocus
/>
        </div>

        <div className="date-fields">
          <HeroDateCard
            label="DEPARTURE"
            value={form.date}
            min={new Date().toLocaleDateString("en-CA")}
            onChange={(value) => update({ date: value })}
          />
        </div>

        {error && (
          <div className="flight-form-error" role="alert">
            {error}
          </div>
        )}

        <button
          type="button"
          className="search-submit-btn"
          onClick={handleSearch}
          disabled={citiesLoading}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <circle cx="8.5" cy="8.5" r="5.5" />
            <path d="M15 15l-3-3" />
          </svg>
          Search Buses
        </button>
      </div>
    </div>
  );
}




// ─── Holiday Search ─────────────────────────────────────────────

const HOLIDAY_FORM_KEY = "navHolidaySearchForm";

const HOLIDAY_API_BASE = (
  process.env.REACT_APP_API_URL || "http://localhost:5000"
).replace(/\/+$/, "") + "/api";

export function HolidaySearch({ inNavbar = false } = {}) {
  const navigate = useNavigate();
  const [destinationOpen, setDestinationOpen] = useState(false);
  const HOLIDAY_TYPES = [
    "Honeymoon",
    "Family",
    "Adventure",
    "Beach",
    "Hill Station",
    "International",
  ];

  const [form, setForm] = useState(() =>
    loadCachedForm(HOLIDAY_FORM_KEY, {
      dest: "",
      month: "",
      type: "Beach",
      nights: 3,
    })
  );

  const [destinations, setDestinations] = useState([]);
  const [loadingDestinations, setLoadingDestinations] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    async function loadDestinations() {
      try {
        const response = await fetch(`${HOLIDAY_API_BASE}/packages`);

        if (!response.ok) {
          throw new Error("Unable to load available destinations.");
        }

        const data = await response.json();
        const packages = Array.isArray(data)
          ? data
          : Array.isArray(data.data)
            ? data.data
            : [];

   
const cities = [
  ...new Set(
    packages
      .filter(
        (pkg) =>
          pkg.is_active == null ||
          Number(pkg.is_active) === 1 ||
          pkg.is_active === true
      )
      .map((pkg) => String(pkg.location || "").trim())
      .filter(Boolean)
  ),
].sort((a, b) => a.localeCompare(b));

const filteredDestinations = destinations.filter((city) =>
  city.toLowerCase().includes(form.dest.trim().toLowerCase())
);


        if (active) {
          setDestinations(cities);
          setForm((previous) => ({
            ...previous,
            dest: cities.includes(previous.dest) ? previous.dest : "",
          }));
        }
      } catch (err) {
        if (active) setError(err.message);
      } finally {
        if (active) setLoadingDestinations(false);
      }
    }

    loadDestinations();
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    cacheForm(HOLIDAY_FORM_KEY, form);
  }, [form]);

  const update = (patch) => setForm((previous) => ({ ...previous, ...patch }));

  const explorePackages = () => {
    if (!form.dest.trim()) {
      setError("Please select a destination with available packages.");
      return;
    }

    setError("");

    const params = new URLSearchParams({
      dest: form.dest,
      month: form.month,
      type: form.type,
      nights: String(form.nights),
    });

    navigate(`/holidays?${params.toString()}`);
  };

  return (
    <div className="search-card" data-aos="fade-up" data-aos-delay="100">
      <div className="search-fields">
<div className="city-input-wrap hotel-city-wrap">
  <label className="field-label">
    <Earth size={15} /> DESTINATION
  </label>

  <input
    className="city-input"
    value={form.dest}
    placeholder={
      loadingDestinations
        ? "Loading destinations..."
        : "Where do you want to go?"
    }
    disabled={loadingDestinations}
    autoComplete="off"
    onChange={(event) => {
      update({ dest: event.target.value });
      setError("");
    }}
    onFocus={() => setDestinationOpen(true)}
  />

  {destinationOpen && destinations
    .filter((city) =>
      city.toLowerCase().includes(form.dest.toLowerCase())
    )
    .slice(0, 6).length > 0 && (
      <ul className="city-dropdown">
        {destinations
          .filter((city) =>
            city.toLowerCase().includes(form.dest.toLowerCase())
          )
          .slice(0, 6)
          .map((city) => (
            <li
              key={city}
              onMouseDown={(event) => {
                event.preventDefault();
                update({ dest: city });
                setDestinationOpen(false);
              }}
            >
              <span className="city-dd-icon">
                <MapPinCheck size={18} />
              </span>
              <span>{city}</span>
            </li>
          ))}
      </ul>
    )}
</div>

        <div className="date-fields">
          <HeroMonthCard
            label="TRAVEL MONTH"
            value={form.month}
            onChange={(value) => update({ month: value })}
          />

          <div className="date-field">
            <div className="hero-counter-card">
              <div className="hero-date-card-top">
                <span className="hero-date-card-label">NIGHTS</span>
                <Moon className="hero-date-card-chevron" size={14} />
              </div>

              <div className="hero-counter-row">
                <button
                  type="button"
                  disabled={form.nights <= 1}
                  onClick={() =>
                    update({ nights: Math.max(1, form.nights - 1) })
                  }
                >
                  −
                </button>

                <span className="hero-counter-value">
                  {form.nights} Night{form.nights !== 1 ? "s" : ""}
                </span>

                <button
                  type="button"
                  onClick={() => update({ nights: form.nights + 1 })}
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </div>

        {error && <div className="flight-form-error" role="alert">{error}</div>}

        <button
          type="button"
          className="search-submit-btn"
          disabled={loadingDestinations || destinations.length === 0}
          onClick={explorePackages}
        >
          Explore Packages
        </button>
      </div>

      <div className="holiday-types">
        {HOLIDAY_TYPES.map((type) => (
          <button
            key={type}
            type="button"
            className={`fare-pill ${
              form.type === type ? "fare-pill--active" : ""
            }`}
            onClick={() => update({ type })}
          >
            {type}
          </button>
        ))}
      </div>
    </div>
  );
}




// ─── Main Hero ──────────────────────────────────────────────────

const TABS = [

  { id: "flights", label: "Flights", icon: <Plane/> },

  { id: "hotels", label: "Hotels", icon: <Hotel /> },

  ...(ENABLE_TRAINS

    ? [{ id: "trains", label: "Trains", icon: <Train /> }]

    : []),

  { id: "buses", label: "Buses", icon: <Bus /> },

  { id: "holidays", label: "Holidays", icon: <Palmtree /> },

];



export default function Hero() {

  const navigate = useNavigate();

  const { openChat } = useAIChat();



  const [activeTab, setActiveTab] = useState("flights");



  useEffect(() => {

    AOS.init({

      duration: 700,

      once: true,

      easing: "ease-out-cubic",

      offset: 60,

    });

  }, []);



  const handleAiSearchSubmit = (event) => {

    event.preventDefault();



    const prompt =

      event.currentTarget.elements.aiPrompt?.value?.trim() || "";



    openChat(prompt);

  };



  return (

    <section className="hero-section">

      {/* Hero Background + soft readability overlay */}

      <div className="hero-search-wrapper" data-tab={activeTab}>

        <div className="bg-hero-search" aria-hidden="true" />

        <div className="bg-hero-search__overlay" aria-hidden="true" />



        {/* MakeBeeTrip AI Search — intentionally separate from the white booking container */}

        <div className="hero-ai-search" data-aos="fade-down" data-aos-delay="80">

          <form className="hero-ai-search__form" onSubmit={handleAiSearchSubmit}>



            <div className="hero-ai-search__bar">

              <div className="hero-ai-search__copy">

                <MessageCircle className="hero-ai-search__icon" size={18} />

                <input

                  name="aiPrompt"

                  type="text"

                  placeholder="Plan a 5-day family trip to Kerala"

                  aria-label="Ask MakeBeeTrip AI"

                  autoComplete="off"

                />

              </div>

              <button type="submit" className="hero-ai-search__button">

                <MessageCircle size={17} />

                AI Search

              </button>

            </div>

          </form>

        </div>



        {/* Main white booking container: service tabs + active form */}

        <div className="search-widget" data-aos="fade-up" data-aos-delay="50">

          <div className="service-tabs">

            {TABS.map((tab, i) => (

              <button

                key={tab.id}

                type="button"

                className={`service-tab ${activeTab === tab.id ? "service-tab--active" : ""}`}

                onClick={() => setActiveTab(tab.id)}

                data-aos="fade-down"

                data-aos-delay={i * 60}

              >

                <span className="service-tab__icon">{tab.icon}</span>

                <span className="service-tab__label">{tab.label}</span>

              </button>

            ))}

          </div>



          <div className="search-form-area">

            {activeTab === "flights"  && <FlightSearch />}

            {activeTab === "hotels"   && <HotelSearch />}

            {activeTab === "trains"   && <TrainSearch />}

            {activeTab === "buses"    && <BusSearch />}

            {activeTab === "holidays" && <HolidaySearch />}

          </div>

        </div>



        {/* Trust Badges */}

      <div className="trust-row" data-aos="fade-up" data-aos-delay="200">

        {[

          { icon: <Lock />, text: "Secure Payments" },

          { icon: <EyeOff />, text: "No Hidden Charges" },

          { icon: <Phone />, text: "24/7 Support" },

          { icon: <Check />, text: "Instant Confirmation" },

          { icon: <Recycle />, text: "Easy Cancellation" },

        ].map((b, i) => (

          <div key={i} className="trust-badge" data-aos="zoom-in" data-aos-delay={220 + i * 60}>

            <span>{b.icon}</span>

            <span>{b.text}</span>

          </div>

        ))}

      </div>



</div>





      
     
<section
  className="home-section home-section--airlines"
  data-aos="fade-up"
  data-aos-duration="650"
>
  <div className="home-section__inner home-airlines">
    <div className="home-airlines__intro">
      <span className="home-section__eyebrow">
        FLIGHT DISCOVERY
      </span>

      <h2 className="home-section__title">
        Popular airlines
      </h2>

      <p className="home-section__subtitle">
        Explore flights from airlines available through our flight search.
      </p>

      <span className="home-airlines__accent" aria-hidden="true" />
    </div>

    <div
      className="home-airlines__list"
      aria-label="Popular airlines"
    >
      {HOME_AIRLINES.map((airline, index) => (
        <div
          className={`airline-chip airline-chip--${index + 1}`}
          key={airline.code}
          data-aos="fade-up"
          data-aos-delay={index * 90}
        >
          <span className="airline-chip__code" aria-hidden="true">
            {airline.code}
          </span>

          <span className="airline-chip__name">
            {airline.name}
          </span>

          <span className="airline-chip__detail" aria-hidden="true">
            Available for search
          </span>
        </div>
      ))}
    </div>
  </div>
</section>

<section
        className="home-section home-section--stays"
        data-aos="fade-up"
        data-aos-duration="550"
      >
        <div className="home-section__inner">
          <div className="home-stays">
            <div className="home-stays__visual" aria-hidden="true">
              <img src={Kerala} alt="" loading="lazy" />
              <span className="home-stays__visual-overlay" />
              <span className="home-stays__badge">LIVE HOTEL SEARCH</span>
            </div>

            <div className="home-stays__content">
              <span className="home-section__eyebrow">STAYS</span>
              <h2 className="home-section__title">Find a stay for the trip you already have in mind.</h2>
              <p className="home-section__subtitle">
                Explore hotels that match your destination, travel dates, and preferences. Check live availability and find the right stay for your journey.
              </p>

              <button
                type="button"
                className="home-section__button"
                onClick={() => navigate("/hotels")}
              >
                Search live hotels
                <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        </div>
      </section>

{/* Homepage discovery sections — static content only */}
<section
  className="home-section home-section--services"
  data-aos="fade-up"
  data-aos-duration="550"
>
  <div className="home-section__inner">
    <div className="services-showcase__heading">
      <div className="services-showcase__intro">
        <span className="services-showcase__eyebrow">
          <span className="services-showcase__eyebrow-dot" />
          TRAVEL MADE SIMPLE
        </span>

        <h2 className="services-showcase__title">
          Everything you need
          <br />
          <span> to go further.</span>
        </h2>

        <p className="services-showcase__subtitle">
          From take-off to check-in, bring your travel plans together
          in one beautifully simple place.
        </p>
      </div>

      <div className="services-showcase__aside" aria-hidden="true">
        <span className="services-showcase__aside-orbit">
  <img
    src={MakeBeeTripLogo}
    alt="makebeetrip logo"
    className="services-showcase__brand-icon"
  />
</span>
        <span className="services-showcase__aside-caption">
          YOUR JOURNEY,
          <br />
          YOUR WAY
        </span>
      </div>
    </div>

    <div className="services-showcase__grid">
      {HOME_SERVICES.map((service, index) => {
        const Icon = service.icon;

        const serviceDescriptions = {
          flights: "Domestic and international air travel",
          hotels: "Find stays with live availability",
          buses: "Comfortable intercity journeys",
          holidays: "Discover your next getaway",
        };

        const serviceLabels = {
          flights: "AIR TRAVEL",
          hotels: "YOUR STAY",
          buses: "ROAD JOURNEYS",
          holidays: "GETAWAY IDEAS",
        };

        return (
          <button
            type="button"
            key={service.id}
            className={`services-showcase__card services-showcase__card--${service.id}`}
            onClick={() => navigate(service.route)}
            data-aos="fade-up"
            data-aos-delay={index * 80}
            aria-label={`Explore ${service.title}`}
          >
            <span className="services-showcase__icon-row">
  <span className="services-showcase__icon" aria-hidden="true">
    <Icon size={25} strokeWidth={1.7} />
  </span>

  <span className="services-showcase__category">
    {serviceLabels[service.id] || "TRAVEL"}
  </span>
</span>

            <span className="services-showcase__card-content">
              <span className="services-showcase__card-title">
                {service.title}
              </span>

              <span className="services-showcase__card-text">
                {serviceDescriptions[service.id] || service.text}
              </span>
            </span>

            <span className="services-showcase__card-bottom">
  <span className="services-showcase__explore">
    Explore {service.title.toLowerCase()}
  </span>
  <span className="services-showcase__action" aria-hidden="true">
  </span>
</span>
          </button>
        );
      })}
    </div>

    <div className="services-showcase__footer">
      <span className="services-showcase__footer-line" />
      <p>One place to plan it all. More freedom to enjoy the journey.</p>
      <span className="services-showcase__footer-line" />
    </div>
  </div>
</section>



<section
        className="home-section home-section--destinations"
        data-aos="fade-up"
        data-aos-duration="550"
      >
        <div className="home-section__inner">
          <div className="home-section__heading home-section__heading--split">
            <div>
              <span className="home-section__eyebrow">DESTINATION INSPIRATION</span>
              <h2 className="home-section__title">Places worth planning for</h2>
              <p className="home-section__subtitle">
                Start with an idea, then choose the travel service that fits it.
              </p>
            </div>

            <button
              type="button"
              className="home-section__text-link"
              onClick={() => navigate("/holidays")}
            >
              Explore holidays <span aria-hidden="true">→</span>
            </button>
          </div>

          <div className="destination-mosaic">
            {HOME_DESTINATIONS.map((destination, index) => (
              <button
                type="button"
                className={`destination-tile destination-tile--${index + 1}`}
                key={destination.id}
                onClick={() =>
                  navigate(
                    `/holidays?destination=${encodeURIComponent(destination.query)}`
                  )
                }
                data-aos="fade-up"
                data-aos-delay={index * 45}
              >
                <img
                  src={destination.image}
                  alt={destination.city}
                  className="destination-tile__image"
                  loading={index > 1 ? "lazy" : "eager"}
                />
                <span className="destination-tile__overlay" aria-hidden="true" />
                <span className="destination-tile__content">
                  <span className="destination-tile__city">{destination.city}</span>
                  <span className="destination-tile__category">
                    {destination.category}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

<section
        className="home-section home-section--future"
        data-aos="fade-up"
        data-aos-duration="550"
      >
        <div className="home-section__inner">
          <div className="future-panel">
            <div>
              <span className="home-section__eyebrow">WHAT'S NEXT</span>
              <h2 className="home-section__title">More ways to plan your trip are coming.</h2>
              <p className="home-section__subtitle">
                We are building deeper holiday packages, activities and destination
                inspiration into the MakeBeeTrip experience.
              </p>
            </div>

            <div className="future-panel__items">
              <span>Holiday packages</span>
              <span>Activities</span>
              <span>Destination inspiration</span>
            </div>
          </div>
        </div>
      </section>

<section
        className="home-section home-section--why"
        data-aos="fade-up"
        data-aos-duration="550"
      >
        <div className="home-section__inner">
          <div className="home-section__heading">
            <span className="home-section__eyebrow">WHY MAKEBEETRIP</span>
            <h2 className="home-section__title">One place for the journeys that matter.</h2>
          </div>

          
<div className="why-grid">
  <article className="why-card">
    <span className="why-card__number">01</span>
    <span className="why-card__icon" aria-hidden="true">
      <Earth size={23} />
    </span>
    <h3>One travel hub</h3>
    <p>
      Flights, hotels, buses and holiday discovery in one experience.
    </p>
    <span className="why-card__accent" aria-hidden="true" />
  </article>

  <article className="why-card">
    <span className="why-card__number">02</span>
    <span className="why-card__icon" aria-hidden="true">
      <Check size={23} />
    </span>
    <h3>Clear booking flow</h3>
    <p>
      Search, review your details and continue through the booking journey.
    </p>
    <span className="why-card__accent" aria-hidden="true" />
  </article>

  <article className="why-card">
    <span className="why-card__number">03</span>
    <span className="why-card__icon" aria-hidden="true">
      <Recycle size={23} />
    </span>
    <h3>Easy cancellation</h3>
    <p>
      Cancellation support is built into the travel experience where available.
    </p>
    <span className="why-card__accent" aria-hidden="true" />
  </article>

  <article className="why-card">
    <span className="why-card__number">04</span>
    <span className="why-card__icon" aria-hidden="true">
      <Phone size={23} />
    </span>
    <h3>24/7 support</h3>
    <p>
      Get support when you need help with your travel journey.
    </p>
    <span className="why-card__accent" aria-hidden="true" />
  </article>
</div>

        </div>
      </section>

<section
        className="home-section home-section--cta"
        data-aos="fade-up"
        data-aos-duration="550"
      >
        <div className="home-section__inner">
          <div className="home-cta">
            <div className="home-cta__copy">
              <span className="home-section__eyebrow">READY WHEN YOU ARE</span>
              <h2>Start with your next journey.</h2>
              <p>Search live travel options or explore what is available for your trip.</p>
            </div>

            <div className="home-cta__actions">
              <button
                type="button"
                className="home-cta__button home-cta__button--primary"
                onClick={() => navigate("/flights")}
              >
                Search flights
                <span aria-hidden="true">→</span>
              </button>

              <button
                type="button"
                className="home-cta__button home-cta__button--secondary"
                onClick={() => navigate("/hotels")}
              >
                Find hotels
                <span aria-hidden="true">→</span>
              </button>

              <button
    type="button"
    className="home-cta__button home-cta__button--secondary"
    onClick={() => navigate("/buses")}
  >
    Search buses
    <span aria-hidden="true">→</span>
  </button>
            </div>
          </div>
        </div>
      </section>
</section>

  );

}
